import {HttpBaseService} from "./http-base.service";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {MessageService} from "./message.service";
import {inject, Injectable} from "@angular/core";
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as FileSaver from "file-saver";
import {ProjectCapacityListElement} from "../../../feature/project-total-capacity-list/project-total-capacity.interface";
import {firstValueFrom} from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ProjectTotalCapacityService extends HttpBaseService {
	public http = inject(HttpClient);
	public messageService = inject(MessageService);
	url: string = environment.baseUrl + "api/projects/projectCapacities";

	constructor() {
		super();
	}

	public async getProjectCapacities(
		startMonth: string,
		isMyProjectCapacityView: boolean,
	): Promise<ProjectCapacityListElement[]> {
		return (
			await firstValueFrom(this.getAll<any[]>(this.url + "/" + startMonth + "/" + isMyProjectCapacityView))
		).body.map((result) => ({
			projectName: result.projectName,
			sharePointId: result.sharePointId,
			client: result.client,
			divisionManager: result.divisionManager,
			projectLeader: result.projectLeader,
			projectCapacity: result.valueMap.valueOf(),
			internalEffort: result.internalEffort,
			myProject: result.myProject,
			probabilities: result.probabilities,
			totalCapacitiesPercent: result.totalCapacitiesPercent,
			effortSum: Math.round(Object.values<number>(result.internalEffort).reduce((a, b) => a + b, 0) * 10) / 10,
			projectCapacitySum: Math.round(Object.values<number>(result.valueMap).reduce((a, b) => a + b, 0) * 10) / 10,
			projectResourceLink: result._links.self.href,
			plCluster: result.plCluster === "unknown" ? null : result.plCluster,
			expanded: false,
		}));
	}

	public async getProjectCapacitiesWithBusinessUnit(
		startMonth: string,
		isMyProjectCapacityView: boolean,
		businessUnit: string,
	): Promise<ProjectCapacityListElement[]> {
		return (
			await firstValueFrom(
				this.getAll<any[]>(this.url + "/" + startMonth + "/" + isMyProjectCapacityView + "/" + businessUnit),
			)
		).body.map((result) => ({
			projectName: result.projectName,
			sharePointId: result.sharePointId,
			client: result.client,
			divisionManager: result.divisionManager,
			projectLeader: result.projectLeader,
			projectCapacity: result.valueMap.valueOf(),
			internalEffort: result.internalEffort,
			myProject: result.myProject,
			probabilities: result.probabilities,
			totalCapacitiesPercent: result.totalCapacitiesPercent,
			effortSum: Math.round(Object.values<number>(result.internalEffort).reduce((a, b) => a + b, 0) * 10) / 10,
			projectCapacitySum: Math.round(Object.values<number>(result.valueMap).reduce((a, b) => a + b, 0) * 10) / 10,
			projectResourceLink: result._links.self.href,
			plCluster: result.plCluster === "unknown" ? null : result.plCluster,
			expanded: false,
		}));
	}

	public exportProjectCapacitiesToExcel(projectCapacities: ProjectCapacityListElement[], selectedMonths: string[]) {
		let exportData: {
			sharePointId: string;
			projectName: string;
			client: string;
			divisionManager: string;
			projectCapacitySum: number;
			projectCapacity: number[];
			selectedMonths: string[];
		}[] = [];
		for (let projectCapacity of projectCapacities) {
			const values = selectedMonths.map((month) => {
				const value = projectCapacity.projectCapacity[month];
				return value == null ? 0 : Math.round(value * 10) / 10;
			});
			exportData.push({
				sharePointId: projectCapacity.sharePointId,
				projectName: projectCapacity.projectName,
				client: projectCapacity.client,
				divisionManager: projectCapacity.divisionManager,
				projectCapacitySum: projectCapacity.projectCapacitySum,
				projectCapacity: values,
				selectedMonths: selectedMonths,
			});
		}

		this.http.post(this.url + "/export", exportData, {responseType: "blob"}).subscribe((response) => {
			const blob = new Blob([response], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			FileSaver.saveAs(blob, "project_capacities.xlsx");
		});
	}
}
